import React, { Component } from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { processActions } from "../../reducer/processReducer";
import logoSplash from "../../images/logo_splash.png";

class ChangePassEmail extends Component {
  state = {
    email: "",
  };

  // eslint-disable-next-line consistent-return
  componentDidMount() {
    document.title = "Смяна на парола - Email - A1 Xplore TV GO";

    const { history, process, changePassResetResults } = this.props;

    if (
      !(
        process.changePassEmail &&
        process.changePassCheckEmailResult &&
        process.changePassCheckEmailResult.isOk === true
      )
    ) {
      history.push("/changepass");
      return false;
    }

    this.setState({ email: process.changePassEmail });

    changePassResetResults();
  }

  render() {
    const { email } = this.state;

    return (
      <div className="page page-confirm">
        <div className="header-bg" />

        <div className="container container--small">
          <div className="container-head">
            <img src={logoSplash} alt="" />
          </div>
          <div className="container-body">
            <h1 className="tag-title">Смяна на парола</h1>

            <div className="tag-content">
              <p>Изпратихме ти e-mail с инструкции на</p>
              <h3 className="tag-color-red no-break-out">{email}</h3>
            </div>

            <div className="tag-content tag-content__help" style={{ marginTop: "40px" }}>
              Не получи ли e-mail?{" "}
              <a href="https://help.a1.bg/tv/a1xploretv" className="tag-color-red">
                Помощ
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    process: state.process,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changePassResetResults: () => dispatch(processActions.changePassResetResults()),
  };
}

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(ChangePassEmail);
